// ============================================================================
// marketClientRenderer.tsx — ПРИЛОЖЕНИЕ «Заявки на услуги» (market_client).
//
// Клиентская витрина профи-подобного маркетплейса (hydra.market): клиент
// оставляет заявку, мастера позже берут её в своих приложениях. Рендерер
// регистрируется КЛИЕНТОМ через существующий реестр приложений; серверных
// изменений (proto/миграций/страниц kind='app') нет. Открывается из дока
// (useVisibleApps показывает код только при наличии mkt_requests/mkt_categories)
// или напрямую /designer/app/market_client.
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { MarketApp } from '@/components/market/MarketApp';
import { MARKET_CLIENT_APP_CODE } from '@/lib/marketConstants';

/** Манифест витрины (AppHost): полный экран, работа с заявками и фото. */
export const MARKET_CLIENT_MANIFEST: AppManifest = {
  code: MARKET_CLIENT_APP_CODE,
  name: MARKET_CLIENT_APP_CODE,
  synonym: 'Заявки на услуги',
  appKind: MARKET_CLIENT_APP_CODE,
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['data:read', 'data:write', 'files', 'messenger'],
};

function MarketClientApp() {
  return <MarketApp />;
}

export function registerMarketClientApp(): void {
  registerAppRenderer({
    appKind: MARKET_CLIENT_APP_CODE,
    code: MARKET_CLIENT_APP_CODE,
    title: 'Заявки на услуги',
    Component: MarketClientApp,
    manifest: MARKET_CLIENT_MANIFEST,
  });
}
